import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { FaGoogle, FaMicrosoft, FaLock } from "react-icons/fa";

/**
 * @file Login.js
 * @description Authentication page for Super Admin console. Supports OAuth and Credentials login.
 */

export default function Login() {
    const navigate = useNavigate();
    const location = useLocation();
    const { login } = useAuth();
    const from = location.state?.from?.pathname || "/dashboard";

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleLogin = async (username, pwd) => {
        setLoading(true);
        setError("");
        try {
            await login(username, pwd);
            navigate(from, { replace: true });
        } catch (err) {
            setError(err.message || "Login failed. Please check your credentials.");
        } finally {
            setLoading(false);
        }
    };

    const handleCredsLogin = (e) => {
        e.preventDefault();
        if (email && password) {
            handleLogin(email, password); // API expects username, but form uses email field variable.
            // Note: API doc says "username" in body. 
            // If user enters email as username, that's fine, or we should rename state.
            // Assuming input is "username" or "email" treated as username.
        } else {
            setError("Please enter valid credentials");
        }
    };

    return (
        <div className="d-flex align-items-center justify-content-center min-vh-100 bg-light">
            <div className="card border-0 shadow-lg p-4 custom-login-card" style={{ maxWidth: "400px", width: "100%" }}>
                <div className="text-center mb-4">
                    <div className="bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: 60, height: 60 }}>
                        <FaLock size={24} />
                    </div>
                    <h4 className="fw-bold">Sign In</h4>
                    <p className="text-muted small">Access the Super Admin Console</p>
                </div>

                {/* FORM */}
                <form onSubmit={handleCredsLogin}>
                    {error && <div className="alert alert-danger py-2 small">{error}</div>}
                    <div className="mb-3">
                        <label className="form-label small fw-bold text-secondary">Username / Email</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="username"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>
                    <div className="mb-4">
                        <label className="form-label small fw-bold text-secondary">Password</label>
                        <input
                            type="password"
                            className="form-control"
                            placeholder="••••••••"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                    <button type="submit" className="btn btn-primary w-100 py-2 fw-bold" disabled={loading}>
                        {loading ? "Signing In..." : "Sign In"}
                    </button>
                </form>

                <div className="text-center mt-4">
                    <small className="text-muted d-block mb-2">Don't have an account? <a href="/signup" className="text-primary fw-bold text-decoration-none">Sign Up</a></small>
                    <small className="text-muted">© Copyright Estrel AI Ltd. All Rights Reserved</small>
                </div>
            </div>
        </div>
    );
}
